import {
  Box,
  CircularProgress,
  LinearProgress,
} from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import React from 'react'

export type LoadingSpinnerProps = {
  className?: string
  progress?: number
}

const customThemeSpinner = createTheme({
  palette: {
    primary: {
      main: '#02a6dc',
      contrastText: '#ffffff !important', // --color-dark-blue
    },
  },
})

// TODO Convert this loader into modal
export function LoadingSpinner(props: LoadingSpinnerProps): React.JSX.Element {
  return (
    <ThemeProvider theme={customThemeSpinner}>
      {/**@ts-ignore */}
      <Box className={props.className} overflow="auto" flexGrow="1" key={'box6'}>
        <CircularProgress disableShrink size="7rem" />
      </Box>
    </ThemeProvider>
  )
}

export function LoadingFile(props: LoadingSpinnerProps): React.JSX.Element {
  return (
    <>
      {/**@ts-ignore */}
      < Box className={props.className} flexGrow="2" key={'box6'} >
        <LinearProgress value={props.progress} />
      </Box >
    </>
  )
}
